import React, { useEffect, useState } from 'react';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import PropTypes from 'prop-types';

import FormSummaryGroup from '../formSummaryGroup';
import ProductsSummary from './productsSummary';
import detailsOfficeInternetCopper from './productsDetails/officeInternetCopper';
import detailsOfficeInternetFiber from './productsDetails/officeInternetFiber';
import detailsTelusBusinessWifi from './productsDetails/telusBusinessWifi';
import detailsOfficePhone from './productsDetails/officePhone';
import detailsOptikTv from './productsDetails/optikTv';
import request from '../../utils/request';
import detailsSecureBusiness from './productsDetails/secureBusiness';
import detailsBasicWifiAp from './productsDetails/basicWifiAp';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { FieldRadio } from '../fields';
import RedeemOffer from './componets/RedeemOffer';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { getLocale } from '../../misc';

const QuoteSummary = ({
  formStepFields,
  orderData,
  steps,
  setIsFormValidated,
  setQuoteSummaryData,
  nextStep,
  onchange,
  setCodeBasedPromotions,
  defaultValueCBP,
  defaultValueRO,
  setDueMonthly,
  setDueNow,
  setdisableContinue
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const [selectedOption, setSelectedOption] = useState('');
  const [redeemOfferData, setRedeemOfferData] = useState([]);
  const {
    quoteSummary: {
      productsLabel,
      products: {
        officeInternetCopper,
        officeInternetFiber,
        officePhone,
        telusOptikTv,
        secureBusiness,
        telusBusinessWifi,
        basicWifiAp
      }
    }
  } = localizedStrings;
  const locale = getLocale();

  const [{ fields: contentFulFields } = {}] = formStepFields;
  const { formSummaryGroup, title } = contentFulFields;
  const summaryData = orderData;
  const products = {};
  const {
    WLS: { couponBasedDiscounts, yes, no
    } 
  } = locale === 'en-US' ? EN : FR;

  if (summaryData.productSelection) {
    if (summaryData.productSelection.includes(officeInternetCopper)) {
      products.officeInternetCopper = detailsOfficeInternetCopper(
        orderData,
        steps
      );
    }
    if (summaryData.productSelection.includes(officeInternetFiber)) {
      products.officeInternetFiber = detailsOfficeInternetFiber(
        orderData,
        steps
      );
    }
    if (summaryData.productSelection.includes(telusBusinessWifi)) {
      products.telusBusinessWifi = detailsTelusBusinessWifi(orderData, steps);
    }
    if (summaryData.productSelection.includes(officePhone)) {
      const officePhoneDetails = detailsOfficePhone(orderData, steps);
      if (officePhoneDetails && officePhoneDetails.lines.length) {
        products.officePhone = officePhoneDetails;
      }
    }
    if (summaryData.productSelection.includes(telusOptikTv)) {
      products.optikTv = detailsOptikTv(orderData, steps);
    }
    if (summaryData.productSelection.includes(secureBusiness)) {
      products.secureBusiness = detailsSecureBusiness(
        orderData,
        steps
      );
    }
    if (summaryData.productSelection.includes(basicWifiAp)) {
      products.basicWifiAp = detailsBasicWifiAp(orderData, steps);
    }
    const { id } = orderData;
    delete orderData[products];
    orderData.products = products;
    request.put(`/orders/${id}`, orderData).then(() => {});
  }
  const summaryReqObj = products;

  useEffect(() => {
    setIsFormValidated(false);
    if (selectedOption === 'no') {
      onchange({});
      setRedeemOfferData([]);
    }
  }, [selectedOption]);

  useEffect(() => {
    setQuoteSummaryData(summaryReqObj);
    nextStep({ preventDefault: () => {} });
  }, []);

  useEffect(() => {
    if (selectedOption === 'yes' && redeemOfferData.length) {
      setdisableContinue(true);
    } else if (selectedOption === 'no') {
      setdisableContinue(true);
    } else {
      setdisableContinue(false);
    }
  }, [selectedOption, redeemOfferData]);

  useEffect(() => {
    setCodeBasedPromotions({ codeBasedPromotions: selectedOption });
  }, [selectedOption]);

  useEffect(() => {
    setSelectedOption(defaultValueCBP);
  }, [orderData]);

  return (
    <>
      <FieldRadio
        data={{
          name: 'codeBasedPromotions',
          label: couponBasedDiscounts,
          required: true,
          noteAppearsBelowField: false,
          isShowNoteBackground: false,
          readonly: false,
          disabled: false,
          value: selectedOption,
          onChange: e => setSelectedOption(e.target.value),
          options: [
            {
              fields: {
                label: yes,
                value: 'yes',
                disabledOption: false
              }
            },
            {
              fields: {
                label: no,
                value: 'no',
                disabledOption: false
              }
            }
          ]
        }}
      />

      <ExpandCollapse
        tag="h2"
        topDivider={false}
        open={[
          'summaryCustomerInfo',
          'summaryCustomerProducts',
          'codeBasedPromotions'
        ]}
      >
        {selectedOption === 'yes' && (
          <ExpandCollapse.Panel
            id="codeBasedPromotions"
            header="Coupon Based Discounts"
          >
            <RedeemOffer
              onChange={onchange}
              defaultValueRO={defaultValueRO}
              orderData={orderData}
              setDueMonthly={setDueMonthly}
              setDueNow={setDueNow}
              redeemOfferData={redeemOfferData}
              setRedeemOfferData={setRedeemOfferData}
              setIsFormValidated={setIsFormValidated}
            />
          </ExpandCollapse.Panel>
        )}
        <ExpandCollapse.Panel id="summaryCustomerInfo" header={title}>
          <FormSummaryGroup data={formSummaryGroup} orderData={summaryData} />
        </ExpandCollapse.Panel>
        <ExpandCollapse.Panel
          id="summaryCustomerProducts"
          header={productsLabel}
        >
          <ProductsSummary products={products} />
        </ExpandCollapse.Panel>
      </ExpandCollapse>
    </>
  );
};

QuoteSummary.defaultProps = {
  formStepFields: [],
  orderData: {},
  steps: []
};

QuoteSummary.propTypes = {
  formStepFields: PropTypes.arrayOf(PropTypes.object),
  orderData: PropTypes.objectOf(PropTypes.any),
  steps: PropTypes.arrayOf(PropTypes.any),
  setIsFormValidated: PropTypes.func.isRequired,
  setQuoteSummaryData: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired
};

export default QuoteSummary;
